import googleAnalytics from '@analytics/google-analytics';

const env = process.env.NODE_ENV;

const analyticsConfig = {
  '@global': {
    analytics: {
      app: 'agilytics-static',
      debug: env === 'development',
    },
    google: {
      anonymizeIp: true,
    },
  },
  test: {
    google: {
      trackingId: 'UA-000000000-0',
    },
  },
  development: {
    google: {
      trackingId: 'UA-111566240-3',
    },
  },
  production: {
    google: {
      trackingId: 'UA-111566240-2',
    },
  },
};

function getProviderConfig(provider, env = 'PRODUCTION') {
  return {
    ...(analyticsConfig['@global'][provider] || {}),
    ...((analyticsConfig[env] && analyticsConfig[env][provider]) || {}),
  };
}

function getAnalyticsConfig(env) {
  return {
    ...analyticsConfig['@global'].analytics,
    ...((analyticsConfig[env] && analyticsConfig[env].analytics) || {}),
  };
}

export default function config() {
  return {
    ...getAnalyticsConfig(env),
    plugins: [googleAnalytics(getProviderConfig('google', env))],
  };
}
